var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveInstructorCarousel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "save",
    d: "M12.39,19.284a1,1,0,1,1,1,1A1,1,0,0,1,12.39,19.284ZM28,12.208V25a3,3,0,0,1-3,3H7a3,3,0,0,1-3-3V7A3,3,0,0,1,7,4H19.8a2.979,2.979,0,0,1,2.123.881l5.2,5.207A2.979,2.979,0,0,1,28,12.208ZM20.75,17.4h-9.5V26h9.5ZM26,12.208a1,1,0,0,0-.292-.707l-5.2-5.208A.993.993,0,0,0,19.8,6H7A1,1,0,0,0,6,7V25a1,1,0,0,0,1,1H9.25V17.4a2,2,0,0,1,2-2h9.5a2,2,0,0,1,2,2V26H25a1,1,0,0,0,1-1ZM14.53,8H10.25a1,1,0,0,0,0,2h4.28a1,1,0,0,0,0-2Z",
    transform: "translate(-4 -4)",
    fill: "#51247a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveInstructorCarousel);
export default __webpack_public_path__ + "static/media/saveInstructorCarousel.f59b7bd5.svg";
export { ForwardRef as ReactComponent };